import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listAdminIncidents, dismissAdminIncident, dismissAllAdminIncidents } from '../../../services/adminApi';
import useConfirm from '../shell/useConfirm';
import '../catalog/catalog.css';
import '../orders/orders.css';
import './ops.css';

// Journal des incidents : blocages du serveur, commandes en échec, sauvegardes (réussies ou manquantes), du plus récent au plus ancien.
// Un incident ouvert est en rouge ; refermé, il garde sa ligne. « Prévenu » = l'e-mail aux administrateurs est parti (un seul par incident).

export default function IncidentsSection() {
  const { t, i18n } = useTranslation('admin');
  const [data, setData] = useState(null);
  const [erreur, setErreur] = useState('');
  const [confirmer, confirmation] = useConfirm();

  const charger = useCallback(async () => {
    try { setData(await listAdminIncidents()); setErreur(''); } catch (err) { setErreur(err?.message || t('ops.incidents.failed')); }
  }, [t]);
  useEffect(() => {
    charger();
    const minuteur = setInterval(() => { if (document.visibilityState !== 'hidden') charger(); }, 60000);
    return () => clearInterval(minuteur);
  }, [charger]);

  // Supprimer de l'ecran (2026-10-23) : l'incident ne revient pas, sauf s'il se reproduit (voir backend/services/admin/incidents.js).
  const supprimer = async (id) => {
    try { await dismissAdminIncident(id); await charger(); } catch (err) { setErreur(err?.message || t('ops.incidents.failed')); }
  };
  const toutSupprimer = async () => {
    if (!(await confirmer({ title: t('ops.incidents.clearAllTitle'), message: t('ops.incidents.clearAllBody'), confirmLabel: t('ops.incidents.clearAllYes') }))) return;
    try { await dismissAllAdminIncidents(); await charger(); } catch (err) { setErreur(err?.message || t('ops.incidents.failed')); }
  };

  const quand = (iso) => new Date(iso).toLocaleString(i18n.language, { dateStyle: 'short', timeStyle: 'short' });

  return (
    <section className="adm-card">
      <h2>{t('ops.incidents.title')}</h2>
      <p className="adm-note">{t('ops.incidents.subtitle')}</p>
      {data && data.incidents.length > 0 && (
        <div className="adm-actions">
          <button type="button" className="btn btn-outline btn-sm" onClick={toutSupprimer}>{t('ops.incidents.clearAll')}</button>
        </div>
      )}
      {confirmation}
      {erreur && <p className="adm-error" role="alert">{erreur}</p>}
      {!data && !erreur && <p className="adm-state" role="status">{t('catalog.common.loading')}</p>}
      {data && data.incidents.length === 0 && <p className="adm-note">{t('ops.incidents.empty')}</p>}
      {data && data.incidents.length > 0 && (
        <ul className="adm-tl adm-incidents">
          {data.incidents.map((i) => (
            <li key={i.id} className={i.level === 'error' && !i.resolvedAt ? 'err' : ''}>
              <i aria-hidden="true" />
              <div>
                <b>{quand(i.occurredAt)} · {i.title}</b>
                <small>
                  {i.detail}
                  {i.level === 'error' && i.resolvedAt && i.kind !== 'server' ? ` · ${t('ops.incidents.resolved', { date: quand(i.resolvedAt) })}` : ''}
                  {i.level === 'error' && !i.resolvedAt ? ` · ${t('ops.incidents.open')}` : ''}
                  {i.notified ? ` · ${t('ops.incidents.notified')}` : ''}
                </small>
              </div>
              <button type="button" className="btn btn-outline btn-sm adm-incident-del" onClick={() => supprimer(i.id)} aria-label={t('ops.incidents.deleteAria', { title: i.title })}>{t('ops.incidents.delete')}</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
